import fetchBaseQuery from '@app/api/fetchBaseQuery';
import type { RoleType } from '@app/features/project/models/RoleType';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const permissionsApi = createApi({
    reducerPath: 'lokaliseInternal_permissions',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getRoles: builder.query<RoleType[], { teamId: string }>({
            query: ({ teamId }) => ({
                method: 'GET',
                url: `/permissions/${teamId}/roles`,
            }),
        }),
    }),
});

export const { useGetRolesQuery } = permissionsApi;

export type useRoleReturnType = {
    role: RoleType | null;
    isLoadingRole: boolean;
};

export const useRole = (teamId: string, roleId: number | null, skip = false): useRoleReturnType =>
    useGetRolesQuery(
        { teamId },
        {
            skip,
            selectFromResult: (result) => ({
                role: result.data?.find(({ id }) => id === roleId) ?? null,
                isLoadingRole: result.isLoading,
            }),
        },
    );
